import areUnresolvedFeatureFlags from './are-unresolved-feature-flags';

export default {
  areUnresolvedFeatureFlags,
};
